export const WORKSPACE_INVITE_TOKEN_PARAM = 'workspace_invite_token'
export const AUTH_TOKEN_PARAM = 'auth_token'
export const REDIRECT_URL_PARAM = 'redirect_to'
export const REGISTRATION_TYPE_PARAM = 'registration_type'
export const FORCE_DEFAULT_WORKSPACE_PARAM = 'forceDefaultWorkspace'
export const PROMOTION_CODE_PARAM = 'promotion_code'
